import React from 'react'
import cn from 'classnames'
import type { As, Breakpoint } from '../../types'
import { buildClass, buildClasses } from './helpers'
import { Collection } from './types'

type Size = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 'auto' | 'fill'
type Offset = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
type Order = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
type ColumnProps = {
  children: React.ReactNode | React.ReactNode[]
  as?: As
  size: Size | Collection<Size>
  offset?: Offset | Collection<Offset>
  order?: Order | Collection<Order>
}

const colClass = (size: Size | undefined, breakpoint?: Breakpoint) => {
  const _size = size === 'fill' ? '' : size
  return buildClass<Size | ''>('col')(_size, breakpoint)
}
const offsetClass = buildClass<Offset>('offset')
const orderClass = (value: Order | undefined, breakpoint?: Breakpoint) => {
  if (value === undefined) return ''
  const prefix = breakpoint && breakpoint !== 'xs' ? `${breakpoint}:` : ''
  return `${prefix}order-${value}`
}

const sizeClasses = buildClasses<Size>(colClass)
const offsetClasses = buildClasses<Offset>(offsetClass)
const orderClasses = buildClasses<Order>(orderClass)

export const Column = ({
  children,
  as: Element = 'div',
  size,
  offset,
  order,
}: ColumnProps) => {
  const classes = cn([
    ...sizeClasses(size),
    ...orderClasses(order),
    ...offsetClasses(offset),
  ])

  return <Element className={classes}>{children}</Element>
}
